import React from 'react';
import PageContainer from '../PageContainer';
import './dancer.scss';
import dance1 from '../videos/dance1.mp4';
import dance2 from '../videos/dance2.mp4';
import documentary from '../videos/Skin Remembers official.mp4';
import PageTitle from '../PageTitle';
import { greyText } from '../styles';

export const videos = [
  {
    title: <p><i>The Dancer</i> - Ahmad Joudeh</p>,
    src: dance1,
  },
  {
    title: <p><i>The Sea Sami and Identity Lost</i> - Stina Ravdna Lorås</p>,
    src: dance2,
  },
]

class TheDancer extends React.Component {
  constructor() {
    super();
    this.state = { currentVideo: videos[0] }
    this.mainVideo = React.createRef();
  }


  onPlay(e) {

  }

  onPause(e) {

  }
  render() {
    return (
      <PageContainer {...this.props} className="dancer">
        <div className="page-subtitle">
          <i>Meet a dancer and a stage performer that express their identities through dance and bodily movements</i>
          <br />
          <i style={{ color: greyText, marginBottom: '3rem' }}>Møt en danser og en scenekunstner som uttrykker sine identiteter gjennom dans og kroppslig bevegelse</i>
        </div>
        <div className="dancer-container">


          <div className="main">
            <h2>SHORT DOCUMENTARY ABOUT AHMAD AND STINA</h2>
            <video ref={this.mainVideo} width="640" height="480" controls onPlay={this.onPlay.bind(this)} onPause={this.onPause.bind(this)} >
              <source src={documentary + "#t=0.1"} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
          </div>
          <div className="videos">
            <h2>SOLO DANCES</h2>

            {
              videos.map(video =>
                <div className="video">
                  <video width="300" height="auto" controls onPlay={this.onPlay.bind(this)} onPause={this.onPause.bind(this)} >
                    <source src={video.src + "#t=0.1"} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
                  {video.title}
                </div>
              )
            }
          </div>
        </div>
        <PageTitle>DANCE & IDENTITY</PageTitle>

      </PageContainer>
    );
  }
}

export default TheDancer;
